import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../../cmsConfig';
import { User } from '../../../types/User';
import { Role } from '../../../types/Role';

interface Claim {
  type: string;
  value: any;
}

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({}),
  endpoints: (builder) => ({
    getUserInfo: builder.query<User, void>({
      query: () => ({
        url: `${cmsApiConfig.baseUrl}bff/user`,
        headers: {
          'X-CSRF': '1',
        },
        credentials: 'include',
      }),
      transformResponse: (response: Claim[]) => {
        let claims = {
          sub: response.find((c) => c.type === 'sub')?.value,
          name: response.find((c) => c.type === 'name')?.value,
          givenName: response.find((c) => c.type === 'given_name')?.value,
          familyName: response.find((c) => c.type === 'family_name')?.value,
          parentAccountId: response.find((c) => c.type === 'parentAccountId')
            ?.value,
          bffLogout: response.find((c) => c.type === 'bff:logout_url')?.value,
          bffSessionExpiresIn: response.find(
            (c) => c.type === 'bff:session_expires_in'
          )?.value,
          roles: response
            .filter((c) => c.type === 'role')
            .map((c) => Role[c.value as keyof typeof Role]),
        } as User;

        return claims;
      },
    }),
  }),
});

export const { useGetUserInfoQuery, useLazyGetUserInfoQuery } = userApi;
